import { Box } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';

export const ExtraColumns = [
  {
    heading: 'Due Date',
    dataKey: 'dueDate',
    render: (dueDate: string) => {
      const date = DateTime.fromISO(dueDate);
      return (
        <Box fontSize="xs" padding="sm 0" color="body-secondary">
          {date.isValid ? date.toLocaleString(DateTime.DATE_MED) : '--'}
        </Box>
      );
    },
  },
];
